import React from 'react';
import { animated as a, to, useSpring } from 'react-spring';

export const prefersReducedMotion = (): boolean =>
	typeof window !== 'undefined' &&
	typeof window.matchMedia === 'function' &&
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;

interface Props {
	pages: Array<() => JSX.Element>;
}

/** A single-page card: rises into place when it appears. */
const SingleCardViewer = ({ pages }: Props) => {
	const reduce = prefersReducedMotion();
	const spring = useSpring({
		from: { y: 80, rotateX: 25, opacity: 0, scale: 0.9 },
		to: { y: 0, rotateX: 0, opacity: 1, scale: 1 },
		config: { tension: 170, friction: 22 },
		immediate: reduce,
	});

	return (
		<a.div
			style={{
				opacity: spring.opacity,
				transform: to(
					[spring.y, spring.rotateX, spring.scale],
					(y, rotateX, scale) => `perspective(1200px) translateY(${y}px) rotateX(${rotateX}deg) scale(${scale})`
				),
				boxShadow: '0 20px 45px rgba(0, 0, 0, 0.18), 0 6px 14px rgba(0, 0, 0, 0.1)',
				borderRadius: 4,
			}}
		>
			{pages[0]?.()}
		</a.div>
	);
};

export default SingleCardViewer;
